
export const AFFINITY_CATEGORY_MAX_ZEUS = 30
export const RETARGETING_MAX_ZEUS = 10

export const TARGET_TYPE = {
  OPTIMIZE: 0,
  AFFINITY: 1,
  SEGMENT: 2,
  RETARGET: 3,
  NONTARGET: 4,
}
export const options_zeus_ad_target = [
  {value: TARGET_TYPE.NONTARGET, label: "ノンターゲティング"},
  {value: TARGET_TYPE.OPTIMIZE, label: "自動最適化"},
  {value: TARGET_TYPE.AFFINITY, label: "アフィニティカテゴリ"},
  {value: TARGET_TYPE.SEGMENT, label: "カスタムセグメント"},
  {value: TARGET_TYPE.RETARGET, label: "配信オーディエンス設定（リターゲティング）"},
];
export const options_zeus_ad_target_for_display = [
  {value: TARGET_TYPE.NONTARGET, label: "N"},
  {value: TARGET_TYPE.OPTIMIZE, label: "O"},
  {value: TARGET_TYPE.AFFINITY, label: "A"},
  {value: TARGET_TYPE.SEGMENT, label: "C"},
  {value: TARGET_TYPE.RETARGET, label: "R"},
];

